import { BRAND_NAME } from '../constants'

/**
 * Generates an accessible page title following best practices.
 * Format: "Page Name - Brand Name" or just "Brand Name" for home page.
 *
 * @param pageName - Optional specific page name (e.g., "Module", "Login")
 * @returns Formatted page title string
 *
 * @example
 * getPageTitle() // "Educator"
 * getPageTitle("Login") // "Login - Educator"
 * getPageTitle("Module") // "Module - Educator"
 */
export const getPageTitle = (pageName?: string): string => {
  if (!pageName) {
    return BRAND_NAME
  }

  return `${pageName} - ${BRAND_NAME}`
}
